import React, { useState } from 'react';
import './style.css';

const item = [
  {
    question: 'How many classes will there be in a week?',
    ans: 'There will be 3 classes per week. Days/Timings can be selected by the parents.',
  },
  {
    question: 'What all topics will be taught to kids?',
    ans: "Detailed curriculum is attached under the program offerings. Further, we'll teach the foundational science topics  while covering the exciting astronomy.",
  },
  {
    question: 'Will it be Live?',
    ans: 'Yes, all the classes will be Live, and the recordings of it will also be available.',
  },
  {
    question: 'Is it useful for my child?',
    ans: 'The program will enable your child to take the first step in being an Astronaut. Our expert-made curriculum will ensure your child learns in a fun & productive way.',
  },
];

const instagram = 'https://instagram.com/kalam_labs?utm_medium=copy_link';
const facebook = 'https://www.facebook.com/LabsKalam/';
const twitter = 'https://twitter.com/6pmlive?s=21';
const linkedin = 'https://www.linkedin.com/company/kalam-labs/';

const Faq = ({ homeRef, pricingRef, joinHandler }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (link) => {
    window.open(link);
  };

  return (
    <div className='wrapper-faq'>
      <div className='planet'></div>
      <span className='heading-faq'>FAQs</span>
      <div className='faq-div'>
        <div className='faq-questions'>
          {item.map((item, index) => {
            if (activeIndex === index) {
              return (
                <>
                  <div className='question' key={index}>
                    <div className='question-text-div'>
                      <div className='question-bubble'></div>
                      <span className='question-text'>{item.question}</span>
                    </div>
                    <div className='question-arrow'></div>
                  </div>
                  <div className='mobile-ans'>
                    <span className='mobile-ans-text'>{item.ans}</span>
                  </div>
                </>
              );
            } else {
              return (
                <div
                  className='question'
                  style={{
                    background: 'white',
                    fontFamily: 'Roboto-regular',
                    opacity: '0.7',
                    // fontWeight: '400',
                  }}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  <div className='question-text-div'>
                    <div className='question-bubble'></div>
                    <span className='question-text'>{item.question}</span>
                  </div>
                  <div className='question-arrow'></div>
                </div>
              );
            }
          })}
        </div>
        <div className='faq-ans'>
          <div className='ans-div'>
            <span className='question'> {item[activeIndex].question}</span>
            <span className='ans'>{item[activeIndex].ans}</span>
          </div>
        </div>
      </div>
      <hr
        style={{ width: '50%', borderTop: '1px solid black', opacity: '0.5' }}
      />
      <div className='main-footer'>
        <div className='footer-content'>
          <div className='footer-box'>
            <div className='footer-logo-div'>
              <div className='footer-logo'></div>
              <div className='footer-texts'>
                <span className='footer-logo-text'>Kalam Labs</span>
                <span className='footer-logo-label'>We Love Science</span>
              </div>
            </div>
            <span className='footer-btn' onClick={joinHandler}>
              Get started
            </span>
          </div>
          <div className='footer-nav'>
            <div className='nav-links'>
              <span className='nav-heading'>
                <b>Important Links</b>
              </span>
              <span
                onClick={() =>
                  window.scrollTo({
                    behavior: 'smooth',
                    top: homeRef.current.offsetTop,
                  })
                }
              >
                Home
              </span>
              <span>About Us</span>
              <span
                onClick={() =>
                  window.scrollTo({
                    behavior: 'smooth',
                    top: pricingRef.current.offsetTop,
                  })
                }
              >
                Pricing
              </span>
              <span style={{ color: '#f7f7f7' }}>Terms and Conditions</span>
              <span style={{ color: '#f7f7f7' }}>Privacy Policy</span>
            </div>
            <div className='nav-links'>
              <span className='nav-heading'>
                <b>Follow us</b>
              </span>
              <span onClick={() => handleClick(facebook)}>Facebook</span>
              <span onClick={() => handleClick(linkedin)}>Linkedin</span>
              <span onClick={() => handleClick(instagram)}>Instagram</span>
              <span onClick={() => handleClick(twitter)}>Twitter</span>
              <span>
                <b>Contact us</b>
              </span>
            </div>
          </div>
        </div>
        <div className='footer-label'>
          <span className='copy-right'>
            Copyright Elixar Systems Pvt Ltd © 2021. All Rights Reserved
          </span>
          <div className='footer-label-div'>
            <span>Made With </span>
            <div className='footer-pic'></div>
            <span> in India</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
